var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:`flash--${_vm.type}`},[_c('span',{staticClass:"flash__icon"},[_vm._t("default")],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.close)?_c('span',{staticClass:"flash__close",on:{"click":function($event){$event.stopPropagation();return _vm.closeMessage.apply(null, arguments)}}},[_vm._v("×")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }